<template>
  <div v-loading ="isLoading">
    <el-select filterable
      class="select-primary"
      size="large"
      placeholder="Selecione ..."
      v-model="eventIdSelected"
      name="eventIdSelected">
      <el-option class="select-primary" value="all" label="Todos"></el-option>
      <el-option v-for="item in events"
                  filterable
                  class="select-primary"
                  :value="item._id"
                  :label="`${item.reference} - ${item.city}`"
                  :key="item._id">
      </el-option>
    </el-select>
    <button @click="handleCommand()" class="btn btn-danger btn-fill btn-wd">
      Colocar documentedAt=null nos Tickets e remover documentos
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      eventIdSelected: '',
      isLoading: false,
      progress: 0,
      total: 0
    }
  },
  computed: {
    events: {
      get () {
        return this.$store.state.events.all
      }
    },
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    ...mapActions('events', {
      fetchEvents: 'fetchAll'
    }),
    handleCommand () {
      this.isLoading = true
      this.total = 0
      let query = Couchdb.collection('tickets')
      if (this.eventIdSelected !== 'all') {
        query.where('eventId', this.eventIdSelected)
      }

      query.get()
      .then(docs => {
        this.isLoading = false
        let docsFiltered = docs.filter(doc => {
          if (doc.documentedAt !== null) {
            return true
          }
          return false
        })

        this.total = docsFiltered.length
        let swalOptions = {
          title: `Existem ${docsFiltered.length} documentedAt!=null.`
        }
        if (docsFiltered.length === 0) {
          swal({
            title: swalOptions.title,
            text: `Todos os tickets estão com documentedAt=null.`,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        } else {
          swal({
            title: swalOptions.title,
            html: `Você quer setar documentedAt=null e apagar os documentos em todos os tickets?`,
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, faça isso!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          })
          .then(async () => {
            for (const item of docsFiltered) {
              await this.exec(item)
              .then(result => {
                if (this.progress === this.total) {
                  this.notifyFinish()
                }
              })
              .catch(err => {
                swal({
                  width: 1000,
                  title: 'Ocorreu um erro ao executar essa ação.',
                  text: JSON.stringify(err),
                  type: 'error',
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false
                })
              })
            }
          })
        }
      })
      .catch(err => {
        console.log(err)
        this.isLoading = false
      })
    },
    async exec (item) {
      let doc = await Couchdb.connection('docs')
      .where('database', 'trg_admin')
      .where('referenceId', item._id)
      .first()

      let deleteDoc = await Couchdb.connection('docs').delete(doc._id)

      let update = await Couchdb.update(item._id, {
        documentedAt: null
      })
      this.progress++
      return [doc, deleteDoc, update]
    },
    notifyFinish () {
      swal({
        title: 'Sucesso',
        text: `Ação executada com sucesso.`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/SetDocumentedAtNullDeleteDoc.vue